<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <template>
            <v-tabs v-model="active_tab">
              <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
              <v-tab
                v-for="(tab, index) in tabs"
                :key="index"
                @click="selected(tab)"
                >{{ tab }}</v-tab
              >
              <v-tabs-items>
                <v-card flat v-if="tabSelected == 'Agendar Visita'">
                  <grid-visita-prev
                    :show="true"
                    :tipeView="'consulta'"
                    :contratoId="contratoId"
                  ></grid-visita-prev>
                </v-card>

                <v-card flat v-if="tabSelected == 'Registrar Visita'">
                  <grid-visita-registra
                    :show="true"
                    :tipeView="'modifica'"
                    :contratoId="contratoId"
                  ></grid-visita-registra>
                </v-card>
              </v-tabs-items>
            </v-tabs>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import GridVisitaPrev from "@/modules/aplicacion/views/visita/GridVisitaAplicacion.vue";
import GridVisitaRegistra from "@/modules/aplicacion/views/visita/GridVisitaRegistra.vue";

export default {
  name: "visita-tab",

  components: {
    Loading,
    GridVisitaPrev,
    GridVisitaRegistra,
  },

  props: {},

  data() {
    return {
      text: "En construccion",
      loading: false,
      proveedor: {},
      contratoId: "",
      tabs: ["Agendar Visita", "Registrar Visita"],
      tabSelect: "",
      tabSelected: "",
      active_tab: "",
      index: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;
    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.loadSelected();
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },

  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.subTabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);
    },
  },
};
</script>
